import React from 'react';
const MainContext = React.createContext({
  isPreview: false,
  hasGTM: false
});
const MainContextProvider = MainContext.Provider;
const MainContextConsumer = MainContext.Consumer;
const AppContext = React.createContext({});
const AppContextProvider = AppContext.Provider;
const AppContextConsumer = AppContext.Consumer;
export { MainContext, MainContextProvider, MainContextConsumer, AppContext, AppContextProvider, AppContextConsumer };
//# sourceMappingURL=index.js.map